export const DescriptionItem = ({ label, children }) => (
  <>
    <dt className="text-sm font-medium text-gray-500">{label}</dt>
    <dd className="mt-1 text-sm text-gray-700">{children}</dd>
  </>
)
